export default {
    name: 'app-search',
    components: {},
    props: {},
    watch: {
        search(val) {
            if (!val || (val.trim().length < 3 && val.trim().length >= 50)) {
                //at least 3 characters
                return;
            }

            this.querySelections(val);
        },
    },
    data() {
        return {
            loading: false,
            search: null,
            select: null,
        };
    },
    mounted() {
        console.log('Component %s mounted.', this.$options.name);
    },

    methods: {
        querySelections(v) {
            clearTimeout(this._timerId);
            this.loading = true;

            this._timerId = setTimeout(() => {
                if (this.search && this.search.trim().length >= 3 && this.search.trim().length < 50) {
                    this.loadData();
                }

                this.loading = false;
            }, 400);
        },
        loadData() {
            let params = {
                searchQuery: this.search,
            };

            this.$store.dispatch('SearchModule/list', params).then(() => {
                this.loading = false;
            });
        },
        clear() {
            this.items = [];
        },
        toggleFavoriteEvent: function (item) {
            this.$store.dispatch('AppModule/toggleFavoriteEvent', { item: item }, { root: true });
        },
        getScore: function (item) {
            if (!item.sc) {
                return null;
            }

            return item.sc.replace('-', ' - ');
        },
        getTime(item) {
            return item.time.toUpperCase();
        },
        openEvent: function (event, row) {
            //we receive mId by socket but better to have mId on open for avoid data jumping for live events
            if (event.isLive) {
                event['mId'] = this.$const.DBALL_MARKET_LIVE;
            }

            this.$parent.$parent.$parent.$parent.$parent.$refs['event'].open(event, this.$const.TRADING_TYPE_ORDER);
        },
    },
    computed: {
        items: {
            get() {
                return this.$store.getters['SearchModule/getItems'];
            },
            set(value) {
                this.$store.commit('SearchModule/setItems', value);
            },
        },
        favoriteEvent: function () {
            return this.$store.getters['AppModule/getFavoriteEvent'];
        },
        favoriteEventProcessing: {
            get() {
                return this.$store.getters['AppModule/getFavoriteEventProcessing'];
            },
            set(value) {
                this.$store.commit('AppModule/setFavoriteEventProcessing', value);
            },
        },
        user() {
            return this.$store.getters['UserModule/getUser'];
        },
    },
};
